<template>
  <div class="cardCustom">
    <div class="card cardCustom__side">
      <div class="cardCustom__header">
        <div class="cardCustom__header-text">
          <span class="uppercase">
            {{ title }}
          </span>
        </div>
        <div class="cardCustom__header-info__item">
          <button
            v-if="infoText"
            v-tooltip="{
              content: infoText,
              placement: 'bottom-center',
              classes: ['info'],
            }"
          >
            <i class="fas fa-info-circle" />
          </button>
        </div>
      </div>
      <div class="cardContent pt-3 pb-3 small">
        <div class="info">
          <span>CLICK EACH SECTION</span> <br />
          <span>TO SEE MORE DETAIL</span>
        </div>
        <div class="leftMargin position-relative">
          <div v-if="loading" :class="{ bgBlur: true }" :style="blurStyles"></div>
          <doughnut-chart :chartData="chartData" :options="options" :style="myStyles"></doughnut-chart>
          <div v-if="loading" class="loadingSection lds-dual-ring"></div>
        </div>
        <div class="total-value">
          <span class="value">{{ Math.round(footprintInfo.co2_footprint_minus_co2_sequestration) }} lbs</span>
          <br />
          <span class="text">CO2 FOOTPRINT</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from './Card.vue';
import CardWithSides from '@/components/Cards/CardWithSides';
import BarChart from '../../controllers/Charts/BarChart';
import LineChart from '@/controllers/Charts/LineChart';
import DoughnutChart from '@/controllers/Charts/DoughnutChart';

export default {
  name: 'DoughnutChartCard',
  components: {
    DoughnutChart,
    LineChart,
    CardWithSides,
    Card,
  },
  props: {
    infoText: String,
    title: String,
    subTitle: String,
    chartHeight: Number,
    loading: Boolean,
    footprintInfo: Object,
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  computed: {
    myStyles() {
      return {
        height: `${this.chartHeight}px`,
        position: 'relative',
      };
    },
    blurStyles() {
      return {
        height: `${this.chartHeight}px`,
      };
    },
  },
};
</script>
<style>
.cardContent {
  width: 100%;
  height: 100%;
}
.small {
  margin-top: 3rem;
}
.leftMargin {
  margin-left: 30%;
}
.total-value {
  position: absolute;
  top: 55%;
  left: 64%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.value {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.6rem;
  font-weight: 800;
}
.text {
  font-size: 1.1rem;
  text-transform: uppercase;
}
.info {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  position: absolute;
  top: 50%;
  left: 15%;
  transform: translate(-50%, -50%);
  font-size: 1.2rem;
}
</style>
